'use client';

import * as React from 'react';
import mediumZoom from 'medium-zoom';
import './zoom-img.css';

export interface ZoomImgProps {
  children: React.ReactNode;
  className?: string;
}

export function ZoomImg(props: ZoomImgProps): JSX.Element {
  const ref = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (!ref.current) {
      return;
    }
    const zoom = mediumZoom(
      ref.current.querySelectorAll('img:not([data-zoom="false"])'),
      {
        background: 'hsl(0deg 0% 100% / 95%)',
      },
    );

    return () => {
      zoom.detach();
    };
  }, []);
  return <div {...props} ref={ref} />;
}
